<h3 class="title configurator-title">{{ 'decking-boards.configuration.title' | translate }}</h3>
<div class="config-container shadow">
  <!-- Type de terrasse -->
  <h4
    class="title configurator-subtitle collapse-button"
    [ngClass]="{ active: subStep === 1 }"
    (click)="toggleCollapse(1)">
    {{ 'decking-boards.configuration.type-of-terrace' | translate }}
  </h4>
  <div class="collapse-block" *ngIf="subStep === 1">
    <div class="configurator-cards-container">
      <div
        class="configurator-card"
        [ngClass]="{ active: isShapeSelected(shape.id) }"
        *ngFor="let shape of shapes"
        (click)="selectShape(shape)">
        <img [src]="baseImgURL + shape.icon.path" alt="shape-img" class="configurator-card-img" />
        <p class="configurator-card-title" *ngIf="currentLang === 'fr'">{{ shape.nameFr }}</p>
        <p class="configurator-card-title" *ngIf="currentLang === 'en'">{{ shape.nameEn }}</p>
      </div>
      <ng-casto-loader *ngIf="shapes === undefined"></ng-casto-loader>
    </div>
  </div>
</div>

<div class="config-container shadow mt-4">
  <!-- Dimensions de la terrasse -->
  <h4
    class="title configurator-subtitle collapse-button"
    [ngClass]="{
      active: subStep === 2,
      disabled: !configuration.shape,
    }"
    (click)="toggleCollapse(2)">
    {{ 'decking-boards.configuration.size-terrace' | translate }}
    <span class="additional-info float-right mr-4 text-primary" *ngIf="configuration.shape"
      >{{ configuration.shape.sidesNeeded.length }}
      {{ 'decking-boards.configuration.dimensions-fill-in' | translate }}</span
    >
  </h4>
  <div class="collapse-block" *ngIf="subStep === 2">
    <div class="side" *ngFor="let side of getConfigurationSides()">
      <div class="side-name">
        <strong>{{ side.name }}</strong>
      </div>
      <div class="collapse-form">
        <!-- Longueur -->
        <div class="form-row">
          <div class="form-label">
            <label for="length-{{ side.name }}">{{ 'decking-boards.configuration.length' | translate }}</label>
          </div>
          <div class="form-input">
            <div class="m">
              <input
                type="number"
                [step]="0.01"
                [min]="1"
                [value]="calculateLength(side)"
                (change)="updateSide(side, true, $event)"
                [disabled]="!this.configuration.shape.sidesNeeded.includes(side.name)"
                id="length-{{ side.name }}"
                autocorrect="off"
                spellcheck="false" />
            </div>
          </div>
        </div>

        <!-- Habillage de finition -->
        <div class="form-row">
          <div class="form-label">
            <label for="has-finishing-{{ side.name }}">
              {{ 'decking-boards.configuration.has-finishing' | translate }}
              <a class="casto-tooltip" [tooltip]="'decking-boards.configuration.info-finishing' | translate">?</a>
            </label>
          </div>
          <div class="form-switch">
            <span class="mr-2">{{ 'generic.no' | translate }}</span>
            <div class="custom-control custom-switch">
              <input
                type="checkbox"
                [(ngModel)]="side.hasFinishing"
                (change)="updateSide(side, false, undefined)"
                class="custom-control-input"
                id="has-finishing-{{ side.name }}" />
              <label class="custom-control-label" for="has-finishing-{{ side.name }}">{{
                'generic.yes' | translate
              }}</label>
            </div>
          </div>
        </div>

        <!-- Longueur de finition -->
        <div class="form-row" *ngIf="side.hasFinishing">
          <div class="form-label">
            <label for="finishing-length-{{ side.name }}">{{
              'decking-boards.configuration.finishing-length' | translate
            }}</label>
          </div>
          <div class="form-input">
            <div class="m">
              <input
                type="number"
                [step]="0.01"
                [min]="1"
                [value]="side.finishingLength ? convertValueInMeter(side.finishingLength) : 0"
                [max]="convertValueInMeter(side.length)"
                (change)="changeFinishingLength(side, $event)"
                id="finishing-length-{{ side.name }}"
                autocorrect="off"
                spellcheck="false" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="config-container shadow mt-4">
  <!-- Type de pose -->
  <h4
    class="title configurator-subtitle collapse-button"
    [ngClass]="{
      active: subStep === 3,
      disabled: !configuration.shape,
    }"
    (click)="toggleCollapse(3)">
    {{ 'decking-boards.configuration.type-of-installation' | translate }}
  </h4>
  <div class="collapse-block" *ngIf="subStep === 3">
    <div class="configurator-cards-container">
      <div
        class="configurator-card"
        [ngClass]="{
          active: isLayingTypeSelected(layingType),
          disabled: isLayingTypeEnable(layingType.type),
        }"
        *ngFor="let layingType of layingTypes"
        (click)="selectLayingType(layingType)">
        <img [src]="baseImgURL + layingType.icon.path" alt="terrain-img" class="configurator-card-img" />
        <p class="configurator-card-title" *ngIf="currentLang === 'fr'">
          {{ layingType.nameFr }}
          <a
            class="casto-tooltip"
            *ngIf="isLayingTypeEnable(layingType.type)"
            [tooltip]="availableVerticalPattern"
            [delay]="300"
            >?</a
          >
        </p>
        <p class="configurator-card-title" *ngIf="currentLang === 'en'">
          {{ layingType.nameEn }}
          <a
            class="casto-tooltip"
            *ngIf="isLayingTypeEnable(layingType.type)"
            [tooltip]="availableVerticalPattern"
            [delay]="300"
            >?</a
          >
        </p>
        <p class="configurator-card-title" *ngIf="isLayingTypeEnable(layingType.type)">
          {{ 'decking-boards.configuration.not-compatible' | translate }}
        </p>
      </div>
      <ng-casto-loader *ngIf="shapes === undefined"></ng-casto-loader>
    </div>
  </div>
</div>
